import { BasicClient } from "@/utils/httpClient";

export default class PublishDocuments {
  client: BasicClient;
  constructor() {
    this.client = new BasicClient();
  }

  getUploadedFile() {
    return this.client.exec(`/scheduler-taken/`, "GET");
  }

  deleteFile(processTag: any) {
    return this.client.exec(`/scheduler-taken/${processTag}`, "DELETE");
  }

  uploadFile(params: any) {
    return this.client.exec(
      `/v2/admin-mod/publish/documents/massive`,
      "POST",
      params,
      true
    );
  }

  uploadSignFile(params: any) {
    return this.client.exec(
      `/v2/admin-mod/publish/documents/sign-massive`,
      "POST",
      params,
      true
    );
  }

  publish(processTag: any) {
    return this.client.exec(`/scheduler-taken/${processTag}`, "PUT");
  }

  uploadFileToSplit(params: any) {
    return this.client.exec(`/scheduler/split-and-crop`, "POST", params, true);
  }

  getSplitStatus() {
    return this.client.exec(`/scheduler/split-and-crop`, "GET");
  }

  cancelProccess(processTag: String) {
    return this.client.exec(`/scheduler/split-and-crop/${processTag}`, "DELETE");
  }

  signAndPublish(params: String) {
    return this.client.exec(`/scheduler/sign-documents`, "POST", params);
  }
  
  signMassive(params: String) {
    return this.client.exec(`/v2/admin-mod/publish/documents/sign-massive`, "PUT", params);
  }

  getPreviewDocument(params) {
    return this.client.exec(`/v2/admin-mod/publish/documents/preview`, "GET", params);
  }
  downloadSplitCropZip(params){
    return this.client.exec(`/scheduler/split-and-crop/zip`, "GET", params);
  }
}
